import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchBlog } from "../../Redux/WebsiteSlice";
import { getImageUrl } from "../../services/api";
import PageAboutSection from "../Shared/PageAboutSection";
import Reveal from "../Shared/Reveal";
import lower_back from "../../assets/img/reasons-for-lower-back-pain.webp";
import "./BlogList.scss";

const BlogList = () => {
  const dispatch = useDispatch();
  const blog = useSelector((state) => state.website.blog);
  const loading = useSelector((state) => state.website.loading);

  useEffect(() => {
    // Fetch all blogs (pass a large number to get all blogs)
    dispatch(fetchBlog(1000));
  }, [dispatch]);

  if (loading) {
    return (
      <div className="blog-list-loading">
        <div className="loading-message">Loading blogs...</div>
      </div>
    );
  }

  return (
    <div className="main main_blog">
      <div className="page-hero">
        <div className="page-hero__content">
          <span className="small__text">BLOG</span>
          <h1 className="headline__text">
            Latest News <span>& Articles</span>
          </h1>
          <p className="page-hero__subtitle">
            Tips, insights and updates from our physiotherapy team.
          </p>
        </div>
      </div>

      <PageAboutSection
        pageKey="blog"
        fallbackHeading="Insights From Our Team"
        fallbackParagraph="Tips, research-backed advice and updates from our physiotherapists to help you stay informed and active between appointments."
      />

      <div className="hero-width0">
        <div id="beforemain_wrap">
          <main id="main-areaarticle">
            <article id="main-area">
              <section
                id="comp_latest_news_1"
                className="compSection compSection_12 comp_latest_news comp_latest_news_1 textcolor__default"
                data-animate="1"
                style={{ zIndex: 1, paddingTop: "60px" }}
              >
                <div className="row row--articles">
                  {blog && blog.length > 0 ? (
                    <>
                      <Reveal as="div" direction="up" className="articles__wrapper">
                        {blog.map((post) => (
                          <div key={post._id} className="article">
                            <Link
                              className="link-to-post"
                              to={`/blog/${post._id}`}
                            ></Link>
                            <div className="meta">
                              {post.category && (
                                <span className="post__cat">{post.category}</span>
                              )}
                              <h4 className="post__title">
                                {post.title}
                              </h4>
                              {post.author && (
                                <span className="post__author">by {post.author}</span>
                              )}
                            </div>
                            <div className="img_wrap">
                              <img 
                                src={post.image ? getImageUrl(post.image) : lower_back} 
                                alt={post.title}
                                onError={(e) => {
                                  e.target.src = lower_back;
                                }}
                              />
                            </div>
                            <div className="excerpt">
                              {post.excerpt || (post.content ? post.content.substring(0, 150) + '...' : '')}
                            </div>
                            <Link
                              className="site__button site__button_style--solid site__button_shape--default"
                              to={`/blog/${post._id}`}
                            >
                              <span className="text">Read more</span>
                            </Link>
                          </div>
                        ))}
                      </Reveal>
                    </>
                  ) : (
                    <div className="no-blogs-message">
                      <p>No blog posts available at the moment.</p>
                    </div>
                  )}
                </div>
              </section>
            </article>
          </main>
        </div>
      </div>
    </div>
  );
};

export default BlogList;
